/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { ProductListViewType } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductImage, { ProductImageStyles } from "@stoneage/Overrides/Components/ProductImage";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    showImage: boolean;
    imageDimensions?: number;
    extendedStyles?: ProductListProductImageStyles;
    imageClickHandler?: (...args: any[]) => void;
}

type Props = OwnProps & HasProductContext;

export interface ProductListProductImageStyles {
    wrapper?: InjectableCss;
    productImage?: ProductImageStyles;
}

export const productImageStyles: ProductListProductImageStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            margin-bottom: 12px;
            @media (max-width: 1024px) {
                height: 88px;
            }
        `,
    },
};

const ProductListProductImage: FC<Props> = ({ productContext, showImage, imageDimensions, extendedStyles, imageClickHandler }) => {
    const [styles] = useState(() => mergeToNew(productImageStyles, extendedStyles));
    return (
        <StyledWrapper
            {...styles.wrapper}
            data-test-selector="productListProductImage"
            data-test-key={productContext.product.id}
        >
            {showImage && (
                <ProductImage
                    extendedStyles={extendedStyles}
                    product={productContext}
                    imageDimensions={imageDimensions || 308}
                    onClick={() => imageClickHandler?.(productContext?.product.productNumber)}
                />
            )}
        </StyledWrapper>
    );
};

export default withProductContext(ProductListProductImage);
